import { useEffect } from "react";

import Modal from "components/ui/modal";

import drawPromotionModalNotificationCanvas from "../helpers/drawPromotionModalNotificationCanvas";

import DoubleDoobleView from "./doubleDoobleView";
import useGlobalVariables from "hooks/useGlobalVariables";

const PromotionModalNotificationView = ({
	isVisible,
	promotions,
	handleOnOk,
	...otherProps
}) => {
	const { isMobile } = useGlobalVariables();

	useEffect(() => {
		if (!isVisible) {
			return;
		}

		const modalBackground = document.querySelector(".vs--promotion-notification-modal-outside");
		const canvas = document.createElement("canvas");
		canvas.classList.add("vs--promotion-modal-notification-canvas");
		modalBackground.appendChild(canvas);

		drawPromotionModalNotificationCanvas(canvas, modalBackground);

		return () => {
			canvas.classList.remove("vs--promotion-modal-notification-canvas");
			canvas.remove();
		};
	}, [isVisible]);

	return (
		<Modal
			isOpen={isVisible}
			onCancel={handleOnOk}
			classNames={{ content: `vs--promotion-notification-modal ${isMobile ? 'mobile' : ''}`, outside: "vs--promotion-notification-modal-outside" }}
			onOutsideClick={isMobile ? handleOnOk : () => { }}
			closeIcon={null}
		>
			<DoubleDoobleView {...otherProps} promotions={promotions} handleOnOk={handleOnOk} />
		</Modal>
	);
};
export default PromotionModalNotificationView;
